module.exports = __webpack_public_path__ + "img/nothing.d3f834fd.png";